var _g, _defs, _defs2, _defs3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGame10 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 132,
  height: 96,
  viewBox: "0 0 132 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#game10_svg__filter0_ddi_4438_2197)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M53.3304 75.5771H55.9404V77.8071H47.8304V75.5771H50.6104V68.5371L48.1204 69.9871V67.4471L51.3904 65.5371H53.3204V75.5771H53.3304ZM46.1804 68.9871H43.1004L41.2104 71.4571L39.3304 68.9871H36.2304L39.7104 73.2571L36.0104 77.8071H39.0904L41.2104 75.1071L43.3204 77.8071H46.4304L42.7404 73.2571L46.1904 68.9871H46.1804ZM68.2504 70.2971C68.0904 68.4571 67.6003 66.9271 66.7504 65.7771C65.5804 64.1871 63.8504 63.3471 61.7304 63.3471C59.6104 63.3471 57.8904 64.1871 56.7204 65.7671C56.0304 66.6971 55.5704 67.8671 55.3304 69.2471V63.5371H50.8604L50.3904 63.8071L48.6804 64.8071L30.4104 40.2371C29.7704 39.3771 29.9004 38.1671 30.7004 37.5471L55.3104 18.3671C56.1104 17.7471 57.2804 17.9371 57.9204 18.7971L60.0904 21.7071L60.6204 22.4171L61.1504 23.1271L65.0204 28.3371L84.7904 54.9371C85.4304 55.7971 85.3004 57.0071 84.5004 57.6271L68.2603 70.2871L68.2504 70.2971ZM53.4504 28.5171C54.0104 29.5671 55.1904 30.1171 56.0704 29.5171C56.0704 29.5171 56.6904 29.1471 56.7704 28.3571C56.9104 28.8371 57.0204 29.4171 57.0004 30.0871L57.1304 30.2671L58.0504 29.5471L58.9704 28.8271L58.8404 28.6471C58.2004 28.4871 57.6804 28.2271 57.2704 27.9571C58.0404 28.0971 58.5504 27.5771 58.5504 27.5771C59.3504 26.8671 59.1504 25.5571 58.3104 24.7271C57.4704 23.8871 55.2704 23.6771 54.7504 23.6671C54.2304 23.6671 53.5404 23.4671 53.5404 23.4671C53.5404 23.4671 53.5404 24.1971 53.4004 24.7171C53.2704 25.2271 52.8804 27.4671 53.4504 28.5171ZM62.1104 52.0471C64.4704 52.4571 66.0504 50.8671 66.0504 50.8671C68.5204 48.6771 67.8804 44.6771 65.3104 42.1071C62.7304 39.5371 55.9704 38.8771 54.3804 38.8671C52.7804 38.8571 50.6704 38.2571 50.6704 38.2571C50.6704 38.2571 50.6704 40.5071 50.2504 42.0871C49.8404 43.6671 48.6604 50.5071 50.3904 53.7371C52.1204 56.9671 55.7204 58.6571 58.4404 56.8071C58.4404 56.8071 60.3604 55.6771 60.6004 53.2371C61.0404 54.6971 61.3604 56.4971 61.3104 58.5571L61.7204 59.1071L64.5404 56.9071L67.3604 54.7071L66.9504 54.1571C65.0004 53.6571 63.3904 52.8671 62.1304 52.0371L62.1104 52.0471ZM101.92 67.4571L89.9004 24.0371C89.6104 23.0071 88.5803 22.3671 87.6003 22.6171L77.4904 25.1771L95.3904 57.9871C95.8204 58.7671 95.9604 59.6771 95.8004 60.5371C95.6404 61.3871 95.1904 62.1371 94.5404 62.6471C94.4004 62.7571 94.2604 62.8471 94.1104 62.9371L68.7104 76.9871C69.1703 77.4071 69.8004 77.5971 70.4203 77.4371L100.66 69.7771C101.64 69.5271 102.21 68.4871 101.92 67.4571ZM61.7304 71.6271C61.7304 71.6971 61.7304 71.7771 61.7304 71.8471C61.7304 71.7771 61.7304 71.7071 61.7304 71.6271ZM93.4904 61.2371C94.2004 60.6871 94.4004 59.6471 93.9403 58.7871L75.8304 25.5971L72.3204 19.1671C71.8104 18.2271 70.6703 17.8571 69.7803 18.3471L62.6104 22.3171L66.7603 27.8971L86.1003 53.9171C87.3204 55.5571 87.0704 57.8571 85.5404 59.0371L68.2704 72.4971C68.2104 73.6171 68.0204 74.6271 67.7204 75.5171L67.9304 75.3971L93.2504 61.3871C93.3304 61.3371 93.4104 61.2871 93.4804 61.2371H93.4904ZM65.1404 66.9571C65.9304 68.0271 66.3204 69.5771 66.3204 71.6171C66.3204 73.6571 65.9304 75.2371 65.1404 76.3371C64.3503 77.4471 63.2104 77.9971 61.7304 77.9971C60.2504 77.9971 59.1204 77.4471 58.3304 76.3371C57.5404 75.2271 57.1404 73.6571 57.1404 71.6271C57.1404 69.5971 57.5404 68.0271 58.3304 66.9571C59.1204 65.8871 60.2604 65.3471 61.7304 65.3471C63.2004 65.3471 64.3503 65.8871 65.1404 66.9571ZM63.7304 71.6271C63.7304 70.6571 63.6604 69.8671 63.5103 69.2671C63.3603 68.6671 63.1404 68.2271 62.8503 67.9571C62.5603 67.6871 62.1804 67.5371 61.7304 67.5371C61.0604 67.5371 60.5604 67.8571 60.2304 68.4971C59.9004 69.1371 59.7304 70.1771 59.7304 71.6271C59.7304 72.5871 59.8104 73.3771 59.9604 73.9971C60.1104 74.6171 60.3304 75.0671 60.6304 75.3671C60.9304 75.6571 61.2904 75.8071 61.7304 75.8071C62.4004 75.8071 62.9004 75.4771 63.2404 74.8071C63.5704 74.1371 63.7404 73.0871 63.7404 71.6371L63.7304 71.6271Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "game10_svg__filter0_ddi_4438_2197",
  x: 0.00390625,
  y: -11.9971,
  width: 131.992,
  height: 119.994,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.808333 0 0 0 0 0.49443 0 0 0 0 0.0235764 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4438_2197"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_4438_2197",
  result: "effect2_dropShadow_4438_2197"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_4438_2197",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect3_innerShadow_4438_2197"
})))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "game10_svg__yellow",
  x1: 30.0052,
  y1: 18.0029,
  x2: 82.8547,
  y2: 93.836,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15625,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.265625,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3125,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46875,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604167,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.973958,
  stopColor: "white"
})))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "game10_svg__gray",
  x1: 30.0052,
  y1: 18.0029,
  x2: 82.8547,
  y2: 93.836,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15625,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.265625,
  stopColor: "#C4C3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3125,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46875,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#C4C3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604167,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#CECEE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.973958,
  stopColor: "white"
})))));
export { SvgGame10 as ReactComponent };
export default __webpack_public_path__ + "assets/icons/game10.29900f.svg";